export class Usuario {
    idcarnet: string;
    expedido:string;
    nombres:string;
    appaterno:string;
    apmaterno:string;
    usuario:string;
    clave:string;
    permisos:Object;
    theme:string;
    estado:string;
    editar:boolean;
    jsonunidad:any;
    constructor(idcarnet='',expedido='',nombres='',appaterno='',apmaterno='',usuario='',clave='',permisos=null,theme='',estado='',editar=false,jsonunidad=null){
        this.idcarnet=idcarnet;
        this.expedido=expedido;
        this.nombres=nombres;
        this.appaterno=appaterno;
        this.apmaterno=apmaterno;
        this.usuario=usuario;
        this.clave=clave;
        this.permisos=permisos;
        this.theme=theme;
        this.estado=estado;
        this.editar=editar;
        this.jsonunidad=jsonunidad;
    }
  }